<template>
  <v-container fluid class="about">
    This is About page.
  </v-container>
</template>

<script>
export default {
  name: "AboutComponent",
  components: {},
  data: () => ({})
};
</script>
<style scoped lang="scss" src="./About.scss"></style>
